// extracted by mini-css-extract-plugin
export default {"Root":"Projects_Root__DzCUm","MainTitle":"Projects_MainTitle__NvWzv","List":"Projects_List__34ZLk"};